import { interactionPromptIndicatorSchema, type InteractionPromptSchema } from '@app/schemas/interaction-prompt';

export function getInteractionPromptText(config: InteractionPromptSchema | undefined, language = 'en-CA'): string {
  const text = config?.text;
  const translated = text?.translations?.[language];
  const fallback = text?.translations?.[text.fallback];
  for (const value of [translated, fallback]) {
    if (typeof value === 'string' && value.length <= 500) return value.trim() ? value : '';
  }
  return '';
}

export function getInteractionPromptIndicatorUri(
  touchIndicator: InteractionPromptSchema['touchIndicator'],
  language = 'en-CA',
): string | undefined {
  if (touchIndicator === undefined) return '/app/animations/touch.json';
  if (touchIndicator?.type === 'gif') {
    const image = touchIndicator.image;
    const translated = image?.translations?.[language];
    const fallback = image?.translations?.[image.fallback];
    // Validate the selected media only: a bad unrelated translation must not hide a valid GIF.
    for (const value of [translated, fallback]) {
      const uri = value?.uri;
      if (typeof uri === 'string' && uri.length <= 2048 && /^file:\/\/\d+$/.test(uri)) return uri;
    }
    return undefined;
  }
  const parsed = interactionPromptIndicatorSchema.safeParse(touchIndicator);
  if (!parsed.success) return undefined;
  switch (parsed.data.type) {
    case 'default': return '/app/animations/touch.json';
    case 'none': return undefined;
    default: return undefined;
  }
}

export function getInteractionPromptRepeatDelay(config: InteractionPromptSchema | undefined): number {
  const seconds = config?.repeatDelay;
  return typeof seconds === 'number' && Number.isFinite(seconds) && seconds >= 0 && seconds <= 3600
    ? seconds * 1000
    : 40_000;
}
